import React, { useEffect, useMemo, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { GLOBAL } from '../../constants/global.const';
import cartApis from '../../apis/cart.api';
import { ProductModel } from '../../models/product.model';
import _ from 'lodash';
import globalUtils from '../../utils/global.util';

const CartIcon = () => {
    const [listProduct, setListProduct] = useState([]);

    const fetchData = async () => {
        try {
            const cartStorage = localStorage.getItem(GLOBAL.CART_STORAGE);

            if (!cartStorage) {
                setListProduct([]);
                return;
            }
            const listItem = JSON.parse(cartStorage);
            if (listItem.length === 0) {
                setListProduct([]);
                return;
            }
            const { status, data } = await cartApis.getCartInfo(listItem);

            if (status !== 200) {
                return;
            }

            const listRes = data.data;
            let listView = [];

            listItem.forEach((item) => {
                const objCheck = listRes.find((o) => o.cp_id == item.id);
                if (objCheck != null) {
                    listView = [
                        new ProductModel({
                            ...objCheck,
                            quantity: item.quantity,
                        }),
                        ...listView,
                    ];
                }
            });

            setListProduct(listView);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    window.addEventListener('storage', ({ key }) => {
        if (key === GLOBAL.CART_STORAGE) {
            fetchData();
        }
    });

    const totalPrice = useMemo(() => {
        if (listProduct.length === 0) return 0;
        return _.sumBy(listProduct, 'total');
    }, [listProduct]);

    const onDeleteItem = (idParam) => {
        const _list = listProduct.filter((o) => o.cp_id != idParam);
        const listStorage = _list.map((o) => {
            return {
                id: o.cp_id,
                quantity: o.quantity,
            };
        });
        localStorage.setItem(GLOBAL.CART_STORAGE, JSON.stringify(listStorage));
        setListProduct(_list);
    };

    const showHtml = () => {
        if (listProduct.length === 0) return null;
        return listProduct.map((item, index) => {
            return (
                <li key={index}>
                    <a href="#" title="" className="cart-product-image">
                        <img
                            src={`${GLOBAL.CDN_LINK}${item.cp_imageid}`}
                            alt={item.cp_name}
                        />
                    </a>
                    <div className="text">
                        <p className="product-name">{item.cp_name}</p>
                        <p className="product-price">
                            <span className="price-old"></span>
                            <span className="price">
                                {item.cp_unitpriceStr}
                            </span>
                        </p>
                        <p className="qty">Số lượng : {item.quantity}</p>
                    </div>
                    <a
                        className="close"
                        title="close"
                        onClick={() => onDeleteItem(item.cp_id)}
                    >
                        <i className="fa fa-times-circle"></i>
                    </a>
                </li>
            );
        });
    };
    return (
        <div className="cart hover-menu">
            <p className="icon-cart" title="Thêm vào giỏ hàng">
                <i className="icon"></i>
                <span className="cart-count">{listProduct.length}</span>
            </p>

            <div className="cart-list list-menu">
                {listProduct.length > 0 ? (
                    <ul className="list">{showHtml()}</ul>
                ) : null}

                <p className="total">
                    <span className="left">Tổng tiền:</span>
                    <span className="right">
                        {globalUtils.formatNumberToPrice(totalPrice)}
                    </span>
                </p>
                <div className="bottom">
                    <a className="link-v1" href="/gio-hang" title="Giỏ hàng">
                        Giỏ hàng
                    </a>
                    <a
                        className="link-v1 rt"
                        href="/thanh-toan"
                        title="Thanh toán"
                    >
                        Thanh toán
                    </a>
                </div>
            </div>
        </div>
    );
};

CartIcon.propTypes = {};

export default CartIcon;

document.querySelectorAll('react-cart-icon').forEach((domContainer) => {
    const root = createRoot(domContainer);

    root.render(<CartIcon />);
});
